// NewsSection.jsx — uses shared BlogCard component
import { useEffect, useRef, useState } from 'react'
import { Link }            from 'react-router-dom'
import { getLatestPosts }  from '@data/blogPosts'
import BlogCard            from '@components/common/BlogCard'

function useFadeIn() {
  const ref = useRef(null)
  const [vis, setVis] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true) },
      { threshold: 0.1 }
    )
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [])
  return [ref, vis]
}

export default function NewsSection() {
  const [ref, vis] = useFadeIn()
  const posts      = getLatestPosts(3)

  return (
    <section style={{ background: '#ffffff', padding: '72px 0' }}>
      <div style={{
        maxWidth: 'var(--container-max)',
        margin:   '0 auto',
        padding:  '0 var(--container-padding)',
      }}>

        {/* Heading + "See all" link */}
        <div style={{
          display:         'flex',
          alignItems:      'flex-end',
          justifyContent:  'space-between',
          gap:             '16px',
          flexWrap:        'wrap',
          marginBottom:    '36px',
        }}>
          <h2 style={{
            fontFamily:    "'DM Sans', sans-serif",
            fontSize:      'clamp(1.5rem, 2.5vw, 2rem)',
            fontWeight:    400,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color:         '#1a1a18',
            margin:        0,
          }}>
            Salient news
          </h2>

          <Link
            to="/blog"
            style={{
              fontFamily:     "'DM Sans', sans-serif",
              fontSize:       '13px',
              fontWeight:     600,
              color:          '#007935',
              textDecoration: 'none',
              display:        'inline-flex',
              alignItems:     'center',
              gap:            '5px',
              paddingBottom:  '2px',
              borderBottom:   '1px solid #007935',
              flexShrink:     0,
              transition:     'opacity 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            See all posts
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 6h8M6 2l4 4-4 4"
                stroke="currentColor" strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>

        {/* 3-col grid — BlogCard handles all the card rendering */}
        <div
          ref={ref}
          className="news-grid"
          style={{
            display:             'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap:                 '28px',
            alignItems:          'start',
          }}
        >
          {posts.map((post, i) => (
            <BlogCard
              key={post.id}
              post={post}
              index={i}
              triggered={vis}
            />
          ))}
        </div>

      </div>

      <style>{`
        @media (max-width: 900px)  { .news-grid { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 560px)  { .news-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  )
}